module.exports = __webpack_public_path__ + "img/course9.75bbcadf.png";